import { RecurringExpenseFrequency } from '../../../domain/expenses/ReccuringExpenseFrequency'
import { AiSuggestionReview, NamedItemInt } from '../../../index'
import { adminHttpClient } from '../../commons/adminHttpClient'
import { NamedItem } from 'domain/common/NamedItem'
import { ExpenseTypeEligibility } from 'domain/expenses/expenseTypeEligibility'

export type ExpenseForReview = {
  expenseId: string
  planPeriodId: string
  companyUser: CompanyUser
  familyMember: NamedItem
  expenseType: NamedItem
  availableFamilyMembers: NamedItem[]
  expenseFor: NamedItem
  approvedExpenseType: NamedItem
  requestedAmount: number
  approvedAmount: number
  purchasedDate: string
  attachments: AttachmentForExpenseResponse[]
  approvedPurchasedDate: string
  serviceProvider: string
  description: string
  expenseNumber: number
  hraDeductibleAmount: number
  costSharingAmount: number
  status: NamedItem
  lockedBy: NamedItem
  planEligibilities: PlanEligibility[]
  expenseTypeEligibility: ExpenseTypeEligibility
  dateSubmitted: string
  lastReview: LastReview
  reviewHistory: string
  availableCannedMessages: CannedMessage[]
  availableExpenseTypes: AvailableExpenseType[]
  canReview: boolean
  requireEobVerification: boolean
  productName: string
  firstSubmittedOn: string
  lastSubmittedAt?: string
  aiSuggestionReview: AiSuggestionReview
  aiSuggestion: NamedItemInt
  restrictedExpenseCategories: NamedItemInt[]
}

type CompanyUser = {
  id: string
  firstName: string
  lastName: string
  workEmail: string
  workPhone: string
}

type PlanEligibility = {
  startDate: string
  endDate: string
  isInPlanYear: boolean
}

type LastReview = {
  expenseTypeReviewStatus: number
  reviewSectionEOBStatus: number
  amountReviewStatus: number
  purchasedDateReviewStatus: number
  messageToEmployee: string
  messageToReviewer: string
  createdAt: string
  overrideAmount?: number
  overrideServiceDate?: string
  overrideFrequency?: RecurringExpenseFrequency
  overrideExpenseTypeId?: number
  overrideServiceProvider?: string
  serviceProviderReviewStatus?: number
  overrideExpenseFor?: NamedItem
  familyMemberReviewStatus?: number
}

type CannedMessage = {
  id: string
  title: string
  message: string
}

type AvailableExpenseType = {
  id: number
  name: string
  eligibilityType: ExpenseTypeEligibility
  isPremium: boolean
}

export type AttachmentForExpenseResponse = {
  id: string
  filename: string
  title: string
  createdAt: string
  dateOfServiceMatch: boolean
  amountSubmittedMatch: boolean
  duplicatedExpenseNumber: number | null
  extractExpenseDataFromFile: ExtractExpenseDataFromFileV2
}
type LabelValue = {
  label: string
  value: string
}
type ExtractExpenseDataFromFile = {
  confidence: number
  vendor: string
  otherVendors: LabelValue[]
  vendorConfidence: number
  receiverName: string
  receiverNameConfidence: number
  invoiceReceiptDate: string
  invoiceReceiptDateConfidence: number
  amountPaid: string
  amountPaidConfidence: number
  otherDates: LabelValue[]
  otherAmounts: LabelValue[]
  otherReceiverNames: LabelValue[]
  otherNames: LabelValue[]
  hsa: LabelValue[]
  rx: LabelValue[]
}

export type ExtractExpenseDataFromFileV2 = {
  totalNumberOfPages: number
  totalNumberOfReceipts: number
  dateOfServiceMatch: boolean
  amountSubmittedMatch: boolean
  duplicatedExpenseNumber: number | null
  items: ExtractExpenseDataFromFileItem[]
}

type ExtractExpenseDataFromFileItem = {
  pageNumber: number
  receiptNumber: number
  vendor: string
  confidence: number
  otherVendors: LabelValue[]
  vendorConfidence: number
  receiverName: string
  receiverNameConfidence: number
  invoiceReceiptDate: string
  invoiceReceiptDateConfidence: number
  amountPaid: string
  amountPaidConfidence: number
  otherDates: LabelValue[]
  otherAmounts: LabelValue[]
  otherReceiverNames: LabelValue[]
  otherNames: LabelValue[]
  hsa: LabelValue[]
  specificHsa: LabelValue[]
  hsaAmountMatch: boolean
  hsaDateMatch: boolean
  rx: LabelValue[]
  neiFields: LabelValue[]
  denyFields: LabelValue[]
  restrictedExpenseCategories: NamedItemInt[]
}

const getExpenseDetailsForReview = (expenseId: string): Promise<ExpenseForReview> => {
  return adminHttpClient.get(`/DocReview/ExpenseForReview/${expenseId}`)
}

export default getExpenseDetailsForReview
